<template>
  <div
    class="dashboard-container"
    :class="{ 'dashboard-is-loading': isLoading }"
  >
    <div
      v-if="isLoading"
      class="dashboard-loading-overlay"
      aria-live="polite"
      aria-busy="true"
    >
      <span
        class="spinner-border text-primary"
        role="status"
        aria-label="Loading"
      ></span>
    </div>
    <div class="row row-cols-1 row-cols-sm-4 mt-3">
      <div class="col-md-3 position-relative">
        <div
          class="card bg-danger rounded-4 border border-4 border-white shadow overflow-hidden"
        >
          <router-link :to="`/students`"
            ><div class="card-body position-relative">
              <div class="d-flex flex-column">
                <h2 class="mb-0 text-white mb-3">{{ CountObj.student }}</h2>
                <h4 class="mb-0 text-white">Student</h4>
              </div>
              <i
                class="fas fa-user-graduate fa-4x position-absolute text-light opacity-25 top-25"
              ></i>
            </div>
          </router-link>
        </div>
      </div>
      <div class="col-md-3 position-relative">
        <div
          class="card bg-info rounded-4 border border-4 border-white shadow overflow-hidden"
        >
          <router-link :to="`/teachers`"
            ><div class="card-body position-relative">
              <div class="d-flex flex-column">
                <h2 class="mb-0 text-white mb-3">{{ CountObj.teacher }}</h2>
                <h4 class="mb-0 text-white">Teacher</h4>
              </div>
              <i
                class="fas fa-chalkboard-teacher fa-4x position-absolute text-light opacity-25 top-25"
              ></i></div
          ></router-link>
        </div>
      </div>
      <div class="col-md-3 position-relative">
        <div
          class="card bg-primary rounded-4 border border-4 border-white shadow overflow-hidden"
        >
          <router-link :to="`/staff`"
            ><div class="card-body position-relative">
              <div class="d-flex flex-column">
                <h2 class="mb-0 text-white mb-3">{{ CountObj.staff }}</h2>
                <h4 class="mb-0 text-white">Staff</h4>
              </div>
              <i
                class="fas fa-users fa-4x position-absolute text-light opacity-25 top-25"
              ></i></div
          ></router-link>
        </div>
      </div>
      <div class="col-md-3 position-relative">
        <div
          class="card bg-success rounded-4 border border-4 border-white shadow overflow-hidden"
        >
          <router-link :to="`/collect`"
            ><div class="card-body position-relative">
              <div class="d-flex flex-column">
                <h2 class="mb-0 text-white mb-3">
                  <i class="fa fa-rupee"></i> {{ CountObj.amount }}
                </h2>
                <h4 class="mb-0 text-white">Collected Today</h4>
              </div>
              <i
                class="fas fa-money-bill-wave fa-4x position-absolute text-light opacity-25 top-25"
              ></i></div
          ></router-link>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title">Boys</h4>
            <PieChart
              :labels="clsBoys.clss"
              :datasets="[
                {
                  label: '',
                  data: clsBoys.counts,
                  backgroundColor: [
                    '#00acc1',
                    '#4fc6e1',
                    '#4a81d4',
                    '#03ff00',
                    '#f1556c',
                    '#f7b84b',
                    '#ff00b4',
                    '#eeff00',
                    '#3a00ff',
                    '#9505ab',
                  ],
                },
              ]"
            />
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title">Girls</h4>
            <PieChart
              :labels="clsGirls.clss"
              :datasets="[
                {
                  label: '',
                  data: clsGirls.counts,
                  backgroundColor: [
                    '#00acc1',
                    '#4fc6e1',
                    '#4a81d4',
                    '#03ff00',
                    '#f1556c',
                    '#f7b84b',
                    '#ff00b4',
                    '#eeff00',
                    '#3a00ff',
                    '#9505ab',
                  ],
                },
              ]"
            />
          </div>
        </div>
      </div>
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title">Teachers</h4>
            <PieChart
              :labels="clsTchrs.clss"
              :datasets="[
                {
                  label: '',
                  data: clsTchrs.counts,
                  backgroundColor: ['#00acc1', '#FF1493'],
                },
              ]"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title">News</h4>
          <hr />
          <div
            id="carouselExampleCaptions"
            class="carousel slide"
            data-bs-ride="carousel"
          >
            <ol class="carousel-indicators list-unstyled">
              <li
                v-for="(news, index) in News"
                :key="index"
                :class="{ active: index === 0 }"
                :data-bs-slide-to="index"
                class="active"
              ></li>
            </ol>
            <div class="carousel-inner">
              <div
                class="carousel-item"
                v-for="(news, index) in News"
                :key="index"
                :class="[{ active: index === 0 }]"
              >
                <div>
                  <img
                    :src="getUrl(news.Image, image_default)"
                    alt="News Image"
                    class="d-block img-fluid carousel-image"
                  />
                </div>
              </div>
            </div>
            <a
              class="carousel-control-prev"
              href="#carouselExampleCaptions"
              role="button"
              data-bs-slide="prev"
            >
              <div class="bg-dark rounded-circle w-75">
                <span
                  class="carousel-control-prev-icon width-control"
                  aria-hidden="true"
                ></span>
              </div>
              <span class="visually-hidden">Previous</span>
            </a>
            <a
              class="carousel-control-next"
              href="#carouselExampleCaptions"
              role="button"
              data-bs-slide="next"
            >
              <div class="bg-dark rounded-circle w-75">
                <span
                  class="carousel-control-next-icon width-control"
                  aria-hidden="true"
                ></span>
              </div>
              <span class="visually-hidden">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title">Announcements</h4>
          <hr />
          <div
            id="announcemtCarousel"
            class="carousel slide"
            data-bs-ride="carousel"
          >
            <ol class="carousel-indicators list-unstyled">
              <li
                v-for="(item1, index) in Announcement"
                :key="index"
                :class="{ active: index === 0 }"
                :data-bs-slide-to="index"
                class="active"
              ></li>
            </ol>
            <div class="carousel-inner">
              <div
                class="carousel-item"
                v-for="(item1, index) in Announcement"
                :key="index"
                :class="[{ active: index === 0 }]"
              >
                <div>
                  <img
                    src="/template/images/announcement_default.jpg"
                    alt="News Image"
                    class="d-block img-fluid carousel-image"
                  />
                  <p class="text-end mb-0" style="margin-top: -40px">
                    {{ item1.Title }}
                  </p>
                  <p class="text-end">{{ disDate(item1.FromDate) }}</p>
                </div>
              </div>
            </div>
            <a
              class="carousel-control-prev"
              href="#announcemtCarousel"
              role="button"
              data-bs-slide="prev"
            >
              <div class="bg-dark rounded-circle w-75">
                <span
                  class="carousel-control-prev-icon width-control"
                  aria-hidden="true"
                ></span>
              </div>
              <span class="visually-hidden">Previous</span>
            </a>
            <a
              class="carousel-control-next"
              href="#announcemtCarousel"
              role="button"
              data-bs-slide="next"
            >
              <div class="bg-dark rounded-circle w-75">
                <span
                  class="carousel-control-next-icon width-control"
                  aria-hidden="true"
                ></span>
              </div>
              <span class="visually-hidden">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 row">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="header-title mb-0">Birthday</h4>
              <div class="d-flex align-items-center gap-1 mb-0">
                <i
                  class="fa fa-print text-primary cursor-pointer fs-4"
                  role="button"
                  @click="print('#birthdayCarousel')"
                ></i>
                <i
                  class="fa fa-download fs-4 cursor-pointer"
                  role="button"
                  @click="download('#birthdayCarousel')"
                ></i>
              </div>
            </div>
            <hr />
            <div
              id="birthdayCarousel"
              class="carousel slide"
              data-bs-ride="carousel"
            >
              <ol class="carousel-indicators list-unstyled">
                <li
                  v-for="(item, index) in combinedList"
                  :key="index"
                  :class="{ active: index === 0 }"
                  :data-bs-slide-to="index"
                ></li>
              </ol>

              <div class="carousel-inner">
                <div
                  class="carousel-item"
                  v-for="(birthday, index) in combinedList"
                  :key="index"
                  :class="{ active: index === 0 }"
                >
                  <img
                    :src="birthday.background"
                    class="d-block w-100 bg-image"
                    style="height: 400px"
                    :class="[
                      birthday.background === '/images/default/bg-3.png'
                        ? 'object-fit-cover'
                        : '',
                    ]"
                  />
                  <div
                    class="carousel-caption d-flex flex-column align-items-center"
                  >
                    <img
                      :src="getUrl(birthday.image, profile_default)"
                      class="birthday-image"
                      alt="photo"
                      width="120"
                      height="100"
                      :class="[
                        birthday.background === '/images/default/bg-2.png'
                          ? 'birthday-image2 rounded-circle'
                          : birthday.background === '/images/default/bg-1.png'
                          ? 'birthday-image1'
                          : birthday.background === '/images/default/bg-3.png'
                          ? 'birthday-image3 rounded-circle'
                          : '',
                      ]"
                    />
                    <h1
                      :class="[
                        birthday.background === '/images/default/bg-2.png'
                          ? 'name-2'
                          : birthday.background === '/images/default/bg-1.png'
                          ? 'name-1 text-white'
                          : birthday.background === '/images/default/bg-3.png'
                          ? 'name-3'
                          : '',
                      ]"
                    >
                      {{ birthday.name }}
                    </h1>
                  </div>
                </div>
              </div>
              <a
                class="carousel-control-prev"
                href="#birthdayCarousel"
                role="button"
                data-bs-slide="prev"
              >
                <div class="bg-dark rounded-circle w-75">
                  <span
                    class="carousel-control-prev-icon width-control"
                    aria-hidden="true"
                  ></span>
                </div>
                <span class="visually-hidden">Previous</span>
              </a>
              <a
                class="carousel-control-next"
                href="#birthdayCarousel"
                role="button"
                data-bs-slide="next"
              >
                <div class="bg-dark rounded-circle w-75">
                  <span
                    class="carousel-control-next-icon width-control"
                    aria-hidden="true"
                  ></span>
                </div>
                <span class="visually-hidden">Next</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="header-title mb-0">Holiday</h4>
              <a
                class="color-darknavy"
                role="button"
                data-bs-toggle="modal"
                data-bs-target="#standard-modal"
                aria-hidden="true"
                >View all</a
              >
            </div>
            <hr />
            <div
              id="holidayCarousel"
              class="carousel slide"
              data-bs-ride="carousel"
            >
              <ol class="carousel-indicators list-unstyled">
                <li
                  v-for="(Holiday, index) in holidays"
                  :key="index"
                  :class="{ active: index === 0 }"
                  :data-bs-slide-to="index"
                  class="active"
                ></li>
              </ol>

              <div class="carousel-inner">
                <div
                  class="carousel-item"
                  v-for="(Holiday, index) in holidays"
                  :key="index"
                  :class="[{ active: index === 0 }]"
                >
                  <img
                    :src="getUrl(Holiday.Image, image_default)"
                    class="carousel-image"
                    alt="Holiday Image"
                  />
                  <p class="fw-bold text-end mb-0" style="margin-top: -55px">
                    {{ Holiday.Name }}
                  </p>
                  <p class="text-end">{{ disDate(Holiday.startDate) }}</p>
                </div>
              </div>
              <a
                class="carousel-control-prev"
                href="#holidayCarousel"
                role="button"
                data-bs-slide="prev"
              >
                <div class="bg-dark rounded-circle w-75">
                  <span
                    class="carousel-control-prev-icon width-control"
                    aria-hidden="true"
                  ></span>
                </div>
                <span class="visually-hidden">Previous</span>
              </a>
              <a
                class="carousel-control-next"
                href="#holidayCarousel"
                role="button"
                data-bs-slide="next"
              >
                <div class="bg-dark rounded-circle w-75">
                  <span
                    class="carousel-control-next-icon width-control"
                    aria-hidden="true"
                  ></span>
                </div>
                <span class="visually-hidden">Next</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="header-title mb-0">Festival</h4>
              <div class="d-flex align-items-center gap-2">
                <i
                  class="fa fa-print text-primary cursor-pointer fs-4 ms-2"
                  role="button"
                  @click="printSlide('#festivalCarousel')"
                ></i>
                <i
                  class="fa fa-download fs-4 cursor-pointer"
                  role="button"
                  @click="downloadImage('#festivalCarousel')"
                ></i>
              </div>
            </div>
            <div class="d-flex flex-row align-items-center mt-3 gap-3">
              <div class="d-flex align-items-center flex-fill gap-1 w-100">
                <label
                  class="form-label fw-bold mb-0"
                  style="white-space: nowrap"
                  >Font:</label
                >
                <div class="btn-group dropup flex-fill">
                  <button
                    type="button"
                    class="btn btn-light btn-sm border border-secondary dropdown-toggle w-100 text-start"
                    data-bs-toggle="dropdown"
                  >
                    {{ selectedFontStyle }}
                    <i class="fa fa-caret-down float-end ms-n2 ms-md-0"></i>
                  </button>
                  <ul class="dropdown-menu scrollable-menu w-100">
                    <li v-for="style in fontStyles" :key="style">
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="selectedFontStyle = style"
                      >
                        {{ style }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="d-flex align-items-center flex-fill gap-1 w-75">
                <label
                  class="form-label fw-bold mb-0"
                  style="white-space: nowrap"
                  >Size:</label
                >
                <div class="btn-group dropup flex-fill">
                  <button
                    type="button"
                    class="btn btn-light btn-sm border border-dark dropdown-toggle w-100 text-start"
                    data-bs-toggle="dropdown"
                  >
                    {{ selectedFontSize }}px
                    <i class="fa fa-caret-down float-end ms-n2 ms-md-0"></i>
                  </button>
                  <ul class="dropdown-menu scrollable-menu w-100">
                    <li v-for="size in fontSizes" :key="size">
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="selectedFontSize = size"
                      >
                        {{ size }}px
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <hr />
            <div
              id="festivalCarousel"
              class="carousel slide"
              data-bs-ride="carousel"
            >
              <ol class="carousel-indicators list-unstyled">
                <li
                  v-for="(item, index) in festivals"
                  :key="index"
                  :class="{ active: index === 0 }"
                  :data-bs-slide-to="index"
                ></li>
              </ol>
              <div class="carousel-inner">
                <div
                  class="carousel-item"
                  v-for="(festival, index) in festivals"
                  :key="index"
                  :class="[{ active: index === 0 }]"
                >
                  <img
                    :src="getUrl(festival.Image, image_default)"
                    class="d-block carousel-image"
                    alt="Festival Image"
                  />
                  <img
                    :src="getUrl(profile?.Image, logo_default)"
                    class="position-absolute top-0 start-0 rounded-circle festival-logo"
                  />
                  <p
                    class="position-absolute top-0 school-name"
                    v-if="profile?.Name"
                    :style="{
                      fontFamily: selectedFontStyle,
                      fontSize: selectedFontSize + 'px',
                    }"
                  >
                    <span
                      v-for="(word, index) in getNameWords()"
                      :key="index"
                      :class="bootstrapColors[index % bootstrapColors.length]"
                      class="me-1"
                    >
                      <strong>{{ word }}</strong>
                    </span>
                  </p>
                </div>
              </div>
              <a
                class="carousel-control-prev"
                href="#festivalCarousel"
                role="button"
                data-bs-slide="prev"
              >
                <div class="bg-dark rounded-circle w-75">
                  <span
                    class="carousel-control-prev-icon width-control"
                    aria-hidden="true"
                  ></span>
                </div>
                <span class="visually-hidden">Previous</span>
              </a>
              <a
                class="carousel-control-next"
                href="#festivalCarousel"
                role="button"
                data-bs-slide="next"
              >
                <div class="bg-dark rounded-circle w-75">
                  <span
                    class="carousel-control-next-icon width-control"
                    aria-hidden="true"
                  ></span>
                </div>
                <span class="visually-hidden">Next</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="standard-modal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="standard-modalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="standard-modalLabel">Holiday 2025</h4>
            <button
              class="btn-close text-end"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div
                class="col-md-6"
                v-for="(Holiday, index) in sortedHolidays"
                :key="index"
              >
                <div class="media" style="margin-bottom: 20px">
                  <div class="media-left">
                    <div
                      style="
                        width: 60px;
                        border-radius: 5px;
                        overflow: hidden;
                        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
                      "
                    >
                      <div
                        :style="{
                          backgroundColor: getHolidayColor(index),
                          fontSize: '14px',
                          fontWeight: 'bold',
                          padding: '4px 0',
                          textAlign: 'center',
                        }"
                      >
                        {{
                          new Date(Holiday.startDate).toLocaleString(
                            "default",
                            { month: "short" },
                          )
                        }}
                      </div>
                      <div style="height: 1px; background: #ddd"></div>
                      <div
                        style="
                          background-color: #fff;
                          color: #000;
                          font-size: 22px;
                          font-weight: bold;
                          padding: 6px 0;
                          text-align: center;
                        "
                      >
                        {{
                          new Date(Holiday.startDate)
                            .getDate()
                            .toString()
                            .padStart(2, "0")
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="media-body p-3">
                    <strong>{{ Holiday.Name }}</strong>
                    <p class="text-muted">
                      {{
                        new Date(Holiday.startDate).toLocaleDateString(
                          "en-GB",
                          {
                            weekday: "long",
                          },
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-info btn-sm"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import html2canvas from "html2canvas";
import axios from "axios";
import { formatDate, api } from "@/utils/helpers.js";
import { ref, onMounted, computed, nextTick } from "vue";
import { useStore } from "vuex";
import { schoolStore } from "@/utils/schoolStore";
import PieChart from "@/components/Common/PieChart.vue";
const selectedFontStyle = ref("Arial");
const selectedFontSize = ref(20);
const fontStyles = ref([
  "Arial",
  "Verdana",
  "Helvetica",
  "Times New Roman",
  "Georgia",
  "Courier New",
  "Trebuchet MS",
  "Lucida Console",
  "Lucida Sans Unicode",
  "Tahoma",
  "Impact",
  "Palatino Linotype",
  "Garamond",
  "Comic Sans MS",
  "Brush Script MT",
  "Copperplate",
  "Franklin Gothic Medium",
  "Gill Sans",
  "Candara",
  "Century Gothic",
  "Segoe UI",
  "Optima",
  "Futura",
  "Cambria",
  "Didot",
  "Rockwell",
  "Baskerville",
]);
const fontSizes = [
  14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50,
  52, 54, 56, 58, 60,
];
const { profile } = schoolStore();
const store = useStore();
const festivals = ref([]);
const holidays = ref([]);
const News = ref([]);
const Announcement = ref([]);
const isLoading = ref(false);
const logo_default = "/images/Logo.png";
const profile_default = "/images/default.png";
const image_default = "/images/festival_default.png";
const CountObj = ref({ student: "", teacher: "", staff: "" });
const List1 = ref([]);
const clsBoys = ref({});
const clsGirls = ref({});
const clsTchrs = ref({});
const backgrounds = ref([
  "/images/default/bg-1.png",
  "/images/default/bg-2.png",
  "/images/default/bg-3.png",
]);
const bootstrapColors = [
  "text-danger",
  "text-warning",
  "text-success",
  "text-primary",
  "text-info",
  "text-secondary",
  "text-dark",
];
const getNameWords = () => {
  return profile.value.Name ? profile.value.Name.split(" ") : [];
};
const combinedList = computed(() => {
  const result = [];
  List1.value.forEach((item) => {
    backgrounds.value.forEach((bg) => {
      result.push({
        name: item.Name,
        image: item.Image,
        description: item.Description,
        background: bg,
      });
    });
  });
  return result;
});
const sortedHolidays = computed(() =>
  [...(holidays.value || [])].sort(
    (a, b) => new Date(a.startDate) - new Date(b.startDate),
  ),
);
const getHolidayColor = (index) => {
  const colors = [
    "#337ab7",
    "#5cb85c",
    "#d9534f",
    "#5bc0de",
    "#f0ad4e",
    "#7952b3",
    "#003366",
  ];
  return colors[index % colors.length];
};
const print = async (selector) => {
  const activeSlide = document.querySelector(
    `${selector} .carousel-inner .active`,
  );
  if (!activeSlide) return;
  const bgImg = activeSlide.querySelector("img.d-block.w-100");
  let oldDisplay = "";
  if (bgImg) {
    oldDisplay = bgImg.style.display;
    bgImg.style.display = "none";
  }
  const images = activeSlide.querySelectorAll("img");
  await Promise.all(
    [...images].map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) resolve();
          else img.onload = img.onerror = resolve;
        }),
    ),
  );
  const canvas = await html2canvas(activeSlide, {
    useCORS: true,
    allowTaint: true,
    backgroundColor: null,
    scale: window.devicePixelRatio * 2,
    onclone: (clonedDoc) => {
      const bg3Slides = clonedDoc.querySelectorAll('img[src$="bg-3.png"]');
      bg3Slides.forEach((bg3Img) => {
        const slide = bg3Img.closest(".carousel-item");
        if (!slide) return;
        bg3Img.style.objectFit = "cover";
        bg3Img.style.width = "100%";
        bg3Img.style.height = "100%";
        const profileImg = slide.querySelector("img.birthday-image3");
        if (profileImg) {
          profileImg.style.borderRadius = "50%";
          profileImg.style.width = "110px";
          profileImg.style.height = "115px";
        }
        const nameEl = slide.querySelector(".name-3");
        if (nameEl) {
          nameEl.style.Top = "calc(6vh + 140px)";
          nameEl.style.marginBottom = "calc(6vh + 15px)";
        }
      });
    },
  });
  if (bgImg) bgImg.style.display = oldDisplay;
  const imgData = canvas.toDataURL("image/png");
  const win = window.open("", "", "width=900,height=700");
  win.document.write(`
    <html>
      <head><title></title></head>
      <body style="margin:0;display:flex;justify-content:center;align-items:center;height:100%;">
        <img src="${imgData}" style="max-width:60%;max-height:60%;" onload="window.print();window.close();">
      </body>
    </html>
  `);
  win.document.close();
};
const printSlide = async (selector) => {
  const activeSlide = document.querySelector(
    `${selector} .carousel-inner .active`,
  );
  if (!activeSlide) return;
  const images = activeSlide.querySelectorAll("img");
  await Promise.all(
    [...images].map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) resolve();
          else img.onload = img.onerror = resolve;
        }),
    ),
  );
  const canvas = await html2canvas(activeSlide, {
    useCORS: true,
    allowTaint: true,
    backgroundColor: null,
    scale: window.devicePixelRatio * 2,
  });
  const imgData = canvas.toDataURL("image/png");
  const win = window.open("", "", "width=900,height=700");
  win.document.write(`
    <html>
      <head><title>Festival</title></head>
      <body style="text-align:center;">
        <img src="${imgData}" style="max-width:80%;max-height:80%;" onload="window.print();window.close();">
      </body>
    </html>
  `);
  win.document.close();
};
const disDate = (d) => {
  return formatDate(d);
};
const downloadImage = async (id) => {
  try {
    const activeSlide = document.querySelector(`${id} .carousel-inner .active`);
    if (!activeSlide) {
      return;
    }
    const clone = activeSlide.cloneNode(true);
    const cloneImages = clone.querySelectorAll("img");
    cloneImages.forEach((img) => {
      img.classList.remove("carousel-image");
    });
    const schoolName = clone.querySelector(".school-name");
    if (schoolName) {
      schoolName.style.fontFamily = selectedFontStyle.value;
      schoolName.style.fontSize = 2 * selectedFontSize.value + "px";
    }
    const wrapper = document.createElement("div");
    wrapper.classList.add("download-mode");
    wrapper.style.display = "inline-block";
    wrapper.style.padding = "0";
    wrapper.style.margin = "0";
    wrapper.style.background = "#fff";
    wrapper.style.textAlign = "center";
    wrapper.appendChild(clone);
    clone.className = "";
    clone.style.margin = "0 auto";
    clone.style.padding = "0";
    wrapper.style.position = "fixed";
    wrapper.style.top = "-10000px";
    wrapper.style.left = "-10000px";
    document.body.appendChild(wrapper);
    await Promise.all(
      [...cloneImages].map((img) => {
        return new Promise((resolve) => {
          if (img.complete) resolve();
          else img.onload = img.onerror = resolve;
        });
      }),
    );
    const canvas = await html2canvas(clone, {
      useCORS: true,
      allowTaint: true,
      scale: 2,
    });
    document.body.removeChild(wrapper);
    const dataUrl = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = "Festival.png";
    link.click();
  } catch (error) {
    return;
  }
};
const download = async (id) => {
  const activeSlide = document.querySelector(`${id} .carousel-inner .active`);
  if (!activeSlide) return;
  const studentName = activeSlide.querySelector("h1")?.innerText.trim() || "";
  const formattedName = studentName.replace(/\s+/g, "-").toLowerCase();
  const images = activeSlide.querySelectorAll("img");
  await Promise.all(
    [...images].map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) resolve();
          else img.onload = img.onerror = resolve;
        }),
    ),
  );
  const canvas = await html2canvas(activeSlide, {
    useCORS: true,
    allowTaint: true,
    backgroundColor: null,
    scale: window.devicePixelRatio * 2,
    onclone: (clonedDoc) => {
      const bg3Slides = clonedDoc.querySelectorAll('img[src$="bg-3.png"]');
      bg3Slides.forEach((bg3Img) => {
        const slide = bg3Img.closest(".carousel-item");
        if (!slide) return;
        bg3Img.style.objectFit = "cover";
        bg3Img.style.width = "100%";
        bg3Img.style.height = "100%";
        const profileImg = slide.querySelector("img.birthday-image3");
        if (profileImg) {
          profileImg.style.borderRadius = "50%";
          profileImg.style.width = "130px";
          profileImg.style.height = "115px";
        }
        const nameEl = slide.querySelector(".name-3");
        if (nameEl) {
          nameEl.style.marginTop = "10px";
          nameEl.style.marginBottom = "25px";
        }
      });
    },
  });
  const dataUrl = canvas.toDataURL("image/png");
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = `birthday-${formattedName}.png`;
  link.click();
};
const loadCls = async () => {
  isLoading.value = true;
  try {
    const responses = await axios.all([
      api.get(`/cls/all`),
      api.get(`/section/all`),
      api.get(`/sub/all`),
      api.get(`/setting/all`),
      api.get(`/ExamType/search`),
      api.get(`/Birthday/all`),
      api.get(`/Festival/all`),
      api.get(`/Holiday/all`),
      api.get(`/news/all`),
      api.get(`/Announcement/all`),
    ]);
    const [
      clsList,
      sectionList,
      subList,
      profile,
      ExamType,
      Birthday,
      Festival,
      Holiday,
      NewsList,
      AnnouncementList,
    ] = responses;

    store.commit("setClasses", clsList.data);
    store.commit("setSections", sectionList.data);
    store.commit("setSubjects", subList.data);
    store.commit("setProfile", profile.data[0]);
    store.commit("setExamTypes", ExamType.data);
    List1.value = Birthday.data;
    festivals.value = Festival.data;
    holidays.value = Holiday.data;
    News.value = NewsList.data;
    Announcement.value = AnnouncementList.data;
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    isLoading.value = false;
  }
};
const loadCommonCounts = async () => {
  try {
    const res = await api.get("/common/all");
    const data = res.data;

    CountObj.value.student = data?.sCount || 0;
    CountObj.value.teacher = data?.tCount || 0;
    CountObj.value.staff = data?.sfCount || 0;
    CountObj.value.amount = data?.todayCollAmt || 0;

    const genderCounts = data.genderCounts || [];
    const classList = store.state.Classes || [];

    const boysLabels = [];
    const boysData = [];
    const girlsLabels = [];
    const girlsData = [];

    genderCounts.forEach((gc) => {
      const cls = classList.find(
        (c) => c._id === gc.classID || c.id === gc.classID,
      );
      if (cls) {
        const className = cls.name || " ";

        if (gc.boysCount > 0) {
          boysLabels.push(className);
          boysData.push(gc.boysCount);
        }
        if (gc.girlsCount > 0) {
          girlsLabels.push(className);
          girlsData.push(gc.girlsCount);
        }
      } else {
        return;
      }
    });
    clsBoys.value = {
      clss: boysLabels,
      counts: boysData,
    };
    clsGirls.value = {
      clss: girlsLabels,
      counts: girlsData,
    };

    clsTchrs.value = {
      clss: ["Male", "Female"],
      counts: [
        data.teacherGender?.maleTeachers || 0,
        data.teacherGender?.femaleTeachers || 0,
      ],
    };
  } catch (err) {
    return;
  }
};

const getUrl = (img, fallback) => {
  let imgUrl = !img ? fallback : img.startsWith("..") ? img.substring(2) : img;

  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
};

onMounted(async () => {
  await loadCls();
  await nextTick();
  loadCommonCounts();
});
</script>
<style>
.dashboard-container {
  position: relative;
}

.dashboard-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 1055;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.55);
  cursor: wait;
}

.bg-3 img.bg-image {
  object-fit: cover !important;
  width: 100% !important;
  height: 100% !important;
}
.carousel-image {
  height: 180px;
  object-fit: fill;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.media-body,
.media-left,
.media-right {
  display: table-cell;
  vertical-align: bottom;
}

.birthday-image1 {
  margin-top: -323px;
  margin-left: -50px;
  height: 90px;
}

.name-1 {
  margin-top: 100px;
  margin-left: -140px;
  font-family: "Brush Script MT", cursive;
}

.name-2 {
  margin-top: -2px;
  margin-bottom: 40px;
  font-family: "Brush Script MT", cursive;
  color: #865e42;
}

.birthday-image2 {
  width: 150px;
  height: 135px;
  margin-left: 12px;
}

.birthday-image3 {
  width: 150px;
  height: 135px;
}

.name-3 {
  margin-top: 22px;
  margin-bottom: 32px;
  font-family: "Brush Script MT", cursive;
  color: #29298a;
}

.width-control {
  width: 15px;
  height: 15px;
  margin-top: 6px;
}

.top-25 {
  top: 25px;
  right: 15px;
}

.school-name {
  z-index: 10;
  margin-left: 45px;
  font-family: cursive;
  font-size: 22px;
  margin-top: 5px;
}

.print-mode .school-name {
  margin-left: 160px !important;
  font-size: 65px !important;
  font-family: cursive !important;
  z-index: 10 !important;
  margin-top: 25px !important;
}

.download-mode .school-name {
  margin-left: 90px !important;
  z-index: 10 !important;
  margin-top: 10px !important;
}

.festival-logo {
  width: 40px;
  z-index: 10;
  margin-top: 2px;
  margin-left: 5px;
}

.print-mode .festival-logo {
  width: 130px !important;
  z-index: 10 !important;
  margin-left: 10px !important;
  margin-top: 5px !important;
}

.download-mode .festival-logo {
  width: 80px !important;
  z-index: 10 !important;
  margin-left: 5px !important;
  margin-top: 3px !important;
}
</style>
